import "./index.css";

function InfoText({children}) {
    return <div className="info-text">{children}</div>
}

export default InfoText;